// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3Ink2","info":"Note_info__2t1ef","note":"Note_note__1BYLM","actions":"Note_actions__2Tn-2"};